import { useMemo } from 'react'
import { t } from '@lingui/macro'
import { useGetEstablishmentConsultationsStatisticsQuery } from '@/core/services/statistics'
import { Category } from '@/core/api/statistics'
import CountByStringComponent from './CountByStringComponent'
import { ChartSkeleton } from '@/features/statistics'

function translateType(label: string): string {
  switch (label) {
    case 'classic':
      return t`Classic`
    case 'emergency':
      return t`Emergency`
    case 'local':
      return t`Local`
    case 'meeting_only':
      return t`Meeting Only`
    case 'netsoins':
      return t`Netsoins`
    case 'pedcl':
      return t`PEDCL`
    default:
      return label
  }
}

type ConsultationTypesProps = {
  establishmentId: string
}

export function ConsultationTypes({ establishmentId }: ConsultationTypesProps) {
  const { data, isLoading } = useGetEstablishmentConsultationsStatisticsQuery({
    category: [Category.type],
    establishment: establishmentId,
  })

  const chart = useMemo(() => {
    return {
      labels: data?.category?.[Category.type]?.chart.labels.map((label) => translateType(label)) ?? [],
      datasets: data?.category?.[Category.type]?.chart.datasets ?? [],
    }
  }, [data])

  if (isLoading) return <ChartSkeleton />

  return <CountByStringComponent chartData={chart} title={t`Consultations by Type`} />
}
